import React from 'react';
import { Row, Col, Space, Image } from 'antd';
import Container from '@/components/container';
import JDImage from '@/components/jd-img';
import { useQueryListCmsChannel } from '@/apis/channelActivity/listCmsChannel';

export default function CmsEntry() {
  const [{ loading, data }] = useQueryListCmsChannel();
  if (loading || !data || !data.cmsList || data.cmsList.length === 0) return null;

  return (
    <Container
      margin={{ horizontal: false, bottom: false, top: true }}
      padding
      style={{ backgroundColor: '#FAFAFA', borderRadius: '8px' }}
    >
      <div style={{ lineHeight: '22px', marginBottom: '7px' }}>我使用的CMS</div>
      <Row gutter={[15, 7]}>
        {data.cmsList.slice(0, 6).map((item) => {
          return (
            <Col key={item.id} span={12}>
              <a
                style={{ display: 'flex', gap: 5, alignItems: 'center' }}
                href={item.cmsLink}
                target="_blank"
                rel="noreferrer"
              >
                <JDImage width={17} height={17} src={item.imageUrl} />
                <div className="ellipsis-1-line">{item.cmsName}</div>
              </a>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}
